import { css } from 'lit';

export const skeletonStyles = css`
  :host {
    --skeleton-bg: #fff;
    --skeleton-gray: var(--fg-gray--300, var(--fg-fallback-gray--300));
    --skeleton-gray-light: var(--fg-gray--100, var(--fg-fallback-gray--100));
    --skeleton-gray-dark: var(--fg-gray--400, var(--fg-fallback-gray--400));
    --skeleton-border-radius: var(
      --fg-borderradius,
      var(--fg-fallback-borderradius)
    );
    --skeleton-border-radius-lg: var(
      --fg-borderradius--lg,
      var(--fg-fallback-borderradius--lg)
    );
    --skeleton-gap-default: 1rem;
    --skeleton-gap-large: 1.5rem;
  }

  .skeleton-container {
    background-color: var(--skeleton-bg);
    border-radius: 10px;
    padding: 15px 12px;
    width: 100%;
    display: block;
  }

  .skeleton-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .skeleton-title {
    background: var(--skeleton-gray);
    border-radius: var(--skeleton-border-radius);
    height: 22px;
    width: 5rem;
  }

  .skeleton-title-large {
    background: var(--skeleton-gray);
    border-radius: var(--skeleton-border-radius);
    height: 1.5rem;
    width: 12rem;
  }

  .skeleton-icon {
    background: var(--skeleton-gray);
    border-radius: var(--skeleton-border-radius);
    height: 1rem;
    width: 1rem;
  }

  .skeleton-text {
    background: var(--skeleton-gray);
    border-radius: var(--skeleton-border-radius);
    height: 1rem;
    width: 10rem;
  }

  .skeleton-block {
    background: var(--skeleton-gray);
    border-radius: var(--skeleton-border-radius);
    width: 100%;
  }

  .skeleton-button {
    background: var(--skeleton-gray);
    border-radius: var(--skeleton-border-radius-lg);
    height: 3rem;
    width: 100%;
  }

  .skeleton-item {
    background: var(--skeleton-gray);
    border-radius: var(--skeleton-border-radius);
    height: 1rem;
  }

  .skeleton-section {
    background-color: var(--skeleton-bg);
    border-radius: var(--skeleton-border-radius-lg);
    padding: var(--skeleton-gap-default);
    width: 100%;
    display: block;
  }
`;
